import { UserProfileBaseView } from 'General/Views/Static/UserProfile/UserProfileBaseView';

export class UserProfileView extends UserProfileBaseView {

}